import api from '@/api'
import * as types from './mutation-types'
import { Notification } from 'element-ui'
import {isEmpty} from 'lodash'
import { saveTokenAndReToken } from '../../../utils/store'

const createState = () => ({
  isLogin: false,
  account: {},
  scoreRecords: [],
  reportRecordList: [],
  pingceUserInfo: {},
  reportAnalyze: {},
  overallReportAnalyze: {},
  reportNumber: '',
  pingceExcel: {},
  reportExcelInfo: {},
  userHotDegree: 0,
  rankingByScore: [0, 0]
})
const state = createState()

const getters = {
  isLogin: state => state.isLogin,
  account: state => state.account,
  scoreRecords: state => state.scoreRecords,
  reportRecordList: state => state.reportRecordList,
  reportAnalyze: state => state.reportAnalyze,
  overallReportAnalyze: state => state.overallReportAnalyze,
  pingceUserInfo: state => state.pingceUserInfo,
  reportExcelInfo: state => state.reportExcelInfo,
  pingceExcel: state => state.pingceExcel,
  reportNumber: state => state.reportNumber,
  userHotDegree: state => state.userHotDegree,
  rankingByScore: state => state.rankingByScore
}

const mutations = {
  [types.LOGIN_SUCCEED] (state) {
    state.isLogin = true
    // 登录状态缓存
    // window.localStorage.USER = JSON.stringify(state.account)
    // window.localStorage.USER_EXPIRATION_DATE = JSON.stringify((new Date()).getTime() + 7 * 24 * 3600 * 1000)
  },
  [types.SET_USER_ACCOUNT] (state, data) {
    state.account = data
  },
  [types.GET_SCORE_RECORDS] (state, data) {
    state.scoreRecords = data
  },
  [types.GET_REPORT_RECORD_LIST] (state, data) {
    state.reportRecordList = data.report_records
  },
  [types.GET_OVERALL_ANALYSIS] (state, data) {
    state.overallReportAnalyze = data
  },
  [types.SET_PINGCE_USER_INFO] (state, data) {
    state.pingceUserInfo = data
  },
  [types.GET_REPORT_EXCEL_INFO] (state, data) {
    state.reportExcelInfo = data
  },
  [types.SET_REPORT_NUMBER] (state, data) {
    state.reportNumber = data.reportNumber
  },
  [types.GET_PINGCE_EXCEL] (state, data) {
    state.pingceExcel = data
  },
  [types.SET_REPORT_ANALYZE] (state, data) {
    state.reportAnalyze = data
    if (!isEmpty(state.reportAnalyze)) {
      const enrollSegment2017 = state.reportAnalyze.history_score.province_score_2017
      const comEnrollSegment2017 = {
        1: null,
        2: null,
        3: null
      }
      enrollSegment2017 && enrollSegment2017.map((item, index) => {
        if (item.segment === index + 1) {
          comEnrollSegment2017[index + 1] = item.score
        }
      })
      state.reportAnalyze.enrollSegment2017 = comEnrollSegment2017
      if (state.reportAnalyze.history_score.major_score_2017 === null) {
        state.reportAnalyze.history_score.major_score_2017 = []
      } else {
        state.reportAnalyze.history_score.major_score_2017 = [state.reportAnalyze.history_score.major_score_2017]
      }
    }
  },
  [types.GET_RANKING_BY_SCORE] (state, data) {
    state.rankingByScore = data
  },
  [types.GET_USER_HOT_DEGREE] (state, data) {
    state.userHotDegree = (data * 100).toFixed(2)
  },
  [types.REST_ZYPC_STORE] (state) {
    const initial = createState()
    Object.keys(initial).forEach(key => { state[key] = initial[key] })
  }
}


const actions = {
  // async refreshToken ({commit}) {
  //   const {data, status = {}} = await api.refreshToken()
  //   if (status === 200) {
  //     commit(types.SET_TOKENS, data)
  //   }
  //   return data
  // },
  async login ({commit}, payload) {
    const {data, status = {}} = await api.login(payload)
    if (status === 200) {
      commit(types.LOGIN_SUCCEED)
      // commit(types.SET_TOKENS, data)
      saveTokenAndReToken(data)
      Notification({
        title: '成功',
        message: '登录成功',
        type: 'success'
      })
    } else {
      Notification({
          title: '失败',
          message: '登录失败',
          type: 'error'
      })
    }
    return data
  },
  async getCode ({commit}, phoneNo) {
    const {data, status = {}} = await api.getCode(phoneNo)
    if (status === 200) {
      Notification({
        title: '成功',
        message: '验证码已发送',
        type: 'success'
      })
    }
    return data
  },
  // 获取用户详细信息 getOwnUser
  async getOwnUser ({commit}) {
    const {data, status = {}} = await api.getOwnUser()
    if (status === 200) {
      commit(types.SET_USER_ACCOUNT, data)
    }
    return data
  },
  // 获取用户成绩列表 getScoreRecords
  async getScoreRecords ({commit}) {
    const {data, status = {}} = await api.getScoreRecords()
    if (status === 200) {
      commit(types.GET_SCORE_RECORDS, data)
    }
    return data
  },
  // 获取预估位次
  async getRankingByScore ({commit}, payload) {
    const {data, status = {}} = await api.getRankingByScore(payload)
    if (status === 200) {
      commit(types.GET_RANKING_BY_SCORE, data.ranking)
    }
    return data
  },
  // 获取志愿梯次指数
  async getUserHotDegree ({commit}, payload) {
    const {data, status = {}} = await api.getUserHotDegree(payload)
    if (status === 200) {
      commit(types.GET_USER_HOT_DEGREE, data.hot_degree)
    }
    return data
  },
  // 保存用户成绩 saveScoreRecords
  async saveScoreRecords ({commit}, payload) {
    const {data, status = {}} = await api.saveScoreRecords(payload)
    if (status === 200) {
      Notification({
        title: '成功',
        message: '保存成功',
        type: 'success'
      })
    } else {
      Notification({
        title: '失败',
        message: '保存失败',
        type: 'error'
      })
    }
    return data
  },
  // 上传excel
  async enrollExcelUpload ({commit}, payload) {
    const {data, status = {}} = await api.enrollExcelUpload(payload)
    if (status === 200) {
      commit(types.GET_REPORT_RECORD_LIST, data.enroll_units)
      commit(types.GET_REPORT_EXCEL_INFO, data)
      commit(types.SET_REPORT_NUMBER, {reportNumber: data.report_number})
      commit(types.GET_PINGCE_EXCEL, data)
      Notification({
        title: '成功',
        message: '上传成功',
        type: 'success'
      })
    } else {
      Notification({
        title: '失败',
        message: '上传失败',
        type: 'error'
      })
    }
    return data
  },
  // 获取志愿评测列表 getReportRecordList
  async getReportRecordList ({commit}) {
    const {data, status = {}} = await api.getReportRecordList()
    if (status === 200) {
      commit(types.GET_REPORT_RECORD_LIST, data)
    }
    return data
  },
  async getSingleReportAnalyze ({commit}, query) {
    const {data = {}} = await api.getSingleReportAnalyze(query)
    commit(types.SET_REPORT_ANALYZE, data)
    return data
  },
  async getOverallAnalysis ({commit}, query) {
    const {data = {}} = await api.getOverallAnalysis(query)
    commit(types.GET_OVERALL_ANALYSIS, data)
    commit(types.SET_PINGCE_USER_INFO, data.user_info)
    return data
  },
  async getReportExcelInfo ({commit}, query) {
    const {data = {}} = await api.getReportExcelInfo(query)
    commit(types.GET_REPORT_EXCEL_INFO, data)
    return data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
